<template>
  <div class="container" v-if="loadingPageOver" :style="iosOrAndroidStyle">
    <w-navbar
      :icon="'iconchevron-left'"
      nav_title="账号设置"
      @mobileLeftBtn="leftBtnClick"
			v-show="iosOrAndroidShow"
    />

		<item name="微信" :placeholder="bindWechat ? '已绑定' : '未绑定'" :showRightIcon="false"/>
		<item name="手机" placeholder="未绑定" @click="bindPhone" :value="phoneText"/>
		<item name="邮箱" placeholder="未绑定" :value="email" v-if="email" :showRightIcon="false"/>

		<item name="设备管理" placeholder="" :showRightIcon="true" @click="toDevice()" />

		<item v-if="isHarmony" name="注销账号" placeholder="" :showRightIcon="true" @click="service" />

  </div>
</template>

<script>
import WNavbar from "@/components/global/w-navbar";
import { envMixin, loginMixin } from '@/assets/js/mixin/global'
import { componentsMixin } from '@/assets/js/mixin/components'
import Item from './components/item';
import Cookies from "js-cookie";
//获取jwt里边的参数
import { getTUser } from '@/utils/utils'
import { phoneDesensitization } from '@/assets/js/utils'

  
export default {
    mixins: [ envMixin, loginMixin, componentsMixin ],
    data () {
      return {
        goBackIcon: 'iconchevron-left',
        userSignedIn: false,
        userInfoData: '',
        phone: '',
        phoneText: '',
        email: '',
        faker_password: '',
        bindWechat: false,
        linkedInConnection: false,
        // 手机号相关
        phoneCodeInputDisabled: false,
        showPhoneCountDown: false,
        phoneCount: '',
        phoneTimer: null,
        // 邮箱相关
        emailCodeInputDisabled: false,
        showEmailCountDown: false,
        emailCount: '',
        emailTimer: null
      }
    },
    computed: {},
    mounted () {
      this.loadPageData()
    },
    components: {
      WNavbar,
      Item
  },
    methods: {
      // 去绑定手机
      bindPhone() {
        this.routeTo(`/account/alter_phone?phone=${this.phone}`);
      },
      leftBtnClick() {
          this.$router.back();
      },
      getTUser() {
        let tUser = {};
        try {
          let _t = Cookies.get("_t");
          let tokenPayload = JSON.parse(window.atob(_t.split(".")[1]));
          tUser = tokenPayload.User;
        } catch (error) {}
        return tUser;
      },
      async service () {
				let res = await this.$api.user.getUdeskOnlineUrl()
				if (res.code !== 1000) {
					this.showToast('网络出错')
					return false
				}
				window.location.href = res.data.udesk_online_url
			},
      async loadPageData () {
        this.userSignedIn = true

        this.$api.auth.getUserBind(this.getTUser().t).then((res) => {
          if (res.code === 1000) {
            this.userInfoData = res.data
            // 手机号脱敏
            this.phone = res.data.phone || '';
            this.phoneText = phoneDesensitization(res.data.phone);
            // this.faker_password = res.data.has_password ? 'xxx' : ''
            this.bindWechat = res.data.wechat_is_bound
            // this.email = res.data.email
            // this.linkedInConnection = res.data.linked_in_connection
          }
        })
        .catch(() => {
            this.showToast('请求错误,请重试!')
        })

      },
      returnFunction () {
        this.$router.back()
      },

      async updateInfo () {
        if (!this.$refs.userPhone.value) {
            this.showToast('请填写手机号');
            return false;
        }
        if (!this.$refs.userPhoneCode.value) {
            this.showToast('请填写验证码');
            return false;
        }
        let params = {
          operation_type: 'bind_phone',
          phone_number: this.$refs.userPhone.value,
          phone_code: this.$refs.userPhoneCode.value,
            // email: this.$refs.userEmail.value,
            // email_token: this.$refs.userEmailCode.value,
            // current_password: this.$refs.userCurrentPassword.value === 'xxx' ? '' : this.$refs.userCurrentPassword.value,
            // password: this.$refs.userPassword.value,
            // password_confirmation: this.$refs.userPasswordConfirmation.value
        }
        this.$api.auth.updatePhone(getTUser().t, params).then((response) => {
          if (response.status === 1) {
              this.loadPageData()
              this.showToast('信息更新成功!')
          } else {
              this.showToast(response.message)
          }
        })
      },

      // 设备管理
      toDevice(){
        this.$router.push('/account/device')
      },
    }
}
</script>
<style scoped lang="scss" rel="stylesheet/scss">
  @import '@/assets/scss/global/mixin';

  .container {
    height: 100%;
		padding-top: 44px;
  }

  .footer {
    @include ipx-content-bottom(1px);
  }

  .mobile-page-container {
    margin-top: 0;
    padding-top: 44px;
  }

  .user-container {
    left: 0;
    right: 0;
    background: #f5f5f7;
    padding-bottom: 20px;
    height: 100%;
  }

  .edit-user-container {
    background-color: #f5f5f7;
    padding-top: 10px;

    .account-info {
      padding: 20px;
      background: #fff;

      .account-info-item {
        margin-bottom: 12px;
        display: flex;
        align-items: center;

        .item-label {
          width: 25%;
        }

        .item-form {
          width: 73%;
          position: relative;
					input {
						width: 100%;
					}

          .item-btn-bind {
            width: 89px;
            height: 32px;
            border-radius: 4px;
            line-height: 32px;
          }

          .not-bind {
            color: #9b9b9b;
          }

          input {
            height: 32px;
            padding-top: 0;
            padding-bottom: 0;
            border-radius: 2px;
          }

          .btn-send {
            position: absolute;
            top: 1px;
            right: 1px;
            line-height: 32px;
            border: none !important;
            font-size: 13px;
            height: 30px;
            padding: 0;
            width: 85px;
            color: #50a4ff;
            background: #f5f5f7;
            text-align: center;
          }
        }
      }

      .one-bottom-btn-fixed-container {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        min-height: 50px;
        background: #fff;
        padding-top: 10px;

        .one-bottom-btn {
          border-radius: 3px;
          text-align: center;
          height: 38px !important;
          width: 91% !important;
          line-height: 38px !important;
          margin: 0 auto;
          font-size: 16px;
          display: block;
					background: #ff4f4c!important;
					color: #fff;
        }
      }
    }
  }
</style>
